module.exports = __webpack_public_path__ + "static/img/irole.fdd9c21.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/u/irole.png
// module id = NetW
// module chunks = 7